import Help from './comands/Help';
import Whoami from './comands/Whoami';
import Cls from './comands/Cls';
import Projects from './comands/Projects';
import Unknown from './comands/Unknown';
export default {
    help:Help,
    whoami:Whoami,
    cls:Cls,
    projects:Projects,
    unknown: Unknown
}